import { ApolloClient, HttpLink, InMemoryCache } from 'apollo-boost'
import { onError } from 'apollo-link-error'
import Vue from 'vue'

// Handler for Error Unauthenticated
const errorHandler = onError(({ graphQLErrors, networkError, operation }) => {
  if (networkError) {
    let messageErr = ''
    if (operation.operationName.indexOf('Pdf') != -1 || operation.operationName.indexOf('Excel')) messageErr = 'Gagal Mengunduh Laporan!'
    else messageErr = 'Failed to fetch'

    Vue.$toast.warning(`${messageErr}`)
  }

  if (graphQLErrors) {
    graphQLErrors.forEach(function (item) {
      if (item.extensions && (item.extensions.code == 'UNAUTHENTICATED' || item.extensions.code == 'INTERNAL_SERVER_ERROR')) {
        localStorage.removeItem('token')
        localStorage.removeItem('domainName')
        localStorage.removeItem('domainNameExpired')
        localStorage.removeItem('payload')

        window.location.href = '/login'
      }
    })
  }
})

const pathName = window.location.pathname.split('/');
var authToken = localStorage.getItem('token');
if(pathName.includes('live-track')) {
  var param = window.location.search;
  const urlParams = new URLSearchParams(param);

  const token = urlParams.get('token')
  authToken = token;
}

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_API_URL,
  headers: {
    authorization: authToken ? `Bearer ${authToken}` : ''
  },
  errorHandler
})

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorHandler.concat(httpLink),
  fetchPolicy: 'no-cache'

})
